var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.336363 3.96098C0.102913 6.13007 0.113321 8.63173 0.438172 10.792C0.617922 11.9873 1.59348 12.9036 2.7977 13.0084L4.05623 13.1177C6.68046 13.3459 9.31946 13.3459 11.9437 13.1177L13.2022 13.0084C14.4065 12.9036 15.382 11.9873 15.5618 10.792C15.8866 8.63173 15.897 6.13023 15.6635 3.96111C15.6334 3.70964 15.5995 3.45852 15.5618 3.20781C15.382 2.01248 14.4065 1.09611 13.2022 0.991425L11.9437 0.882025C9.31946 0.653908 6.68046 0.653908 4.05623 0.882025L2.7977 0.991425C1.59348 1.09611 0.617922 2.01248 0.438172 3.20781C0.40048 3.45847 0.366547 3.70956 0.336363 3.96098ZM4.16448 2.12733C6.71662 1.90547 9.28329 1.90547 11.8355 2.12733L13.094 2.23673C13.7225 2.29138 14.2318 2.76973 14.3256 3.39368C14.3354 3.45848 14.3449 3.52331 14.3541 3.58817L9.71996 6.16273C8.65029 6.75698 7.34962 6.75698 6.27995 6.16273L1.64583 3.5882C1.65505 3.52333 1.66453 3.45849 1.67427 3.39368C1.76811 2.76973 2.27735 2.29138 2.90596 2.23673L4.16448 2.12733ZM14.507 4.93314C14.6687 6.8229 14.6082 8.72698 14.3256 10.6061C14.2318 11.2301 13.7225 11.7084 13.094 11.7631L11.8355 11.8725C9.28329 12.0943 6.71662 12.0943 4.16448 11.8725L2.90596 11.7631C2.27735 11.7084 1.76811 11.2301 1.67427 10.6061C1.3917 8.72698 1.33123 6.82298 1.49287 4.93317L5.67289 7.2554C7.12012 8.0594 8.87979 8.0594 10.327 7.2554L14.507 4.93314Z",
    fill: "#201E2A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLetter);
export default __webpack_public_path__ + "static/media/icon_letter.252f04e6b24772d6e2b8851d7b9256d9.svg";
export { ForwardRef as ReactComponent };